<ngx-json-ld [json]="schema"></ngx-json-ld>
<app-header #header ></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="page-content">

  <div *ngIf="searchHistory.length > 0" class="back-container"><span class="back-btn" (click)="back()">< {{getString('back')}}</span></div>

  <div class="search-title">{{getString('searchTitle')}}</div>

  <div class="search-bar-container">
    <app-search-bar #searchBar [itemTypes]="itemTypes" [selectedItemType]="selectedItemType" [query]="query" [placeholder]="getString('searchbarPlaceholder')" [autoFocus]="true" (onSearchClicked)="searchClicked($event)"></app-search-bar>
  </div>

  <div class="store-media-selectors-container">
    <div class="store-media-selectors-content">
      <app-store-selector class="store-selector-container" [useBrandIcons]="true" (onStoreChanged)="storeChanged()"></app-store-selector>
      <app-media-selector class="media-selector-container" *ngIf="selectedItemTypeFromUrl == 'all'"
      [selectedMediaType]="selectedMedia" [mediaTypes]="mediaTypesForSelector"
      [nolinks]="true" [availableMediaTypes]="availableMediaTypes" (onMediaChanged)="mediaChanged($event)">
      </app-media-selector>
    </div>
  </div>

  <ng-container *ngIf="showAmazonUSItems()">
    <div class="media-results" *ngFor="let media of medias">

      <span [id]="media+'_section'" class="anchor"></span>

      <div *ngIf="searchMode == 'v2' && searchResults && searchResults.length > 0" class="media-title">{{getString(media)}}</div>
      <div *ngIf="searchMode == 'v1' && searchResults[media] && searchResults[media].length > 0" class="media-title">{{getString(media)}}</div>

      <div class="items-container">

        <ng-container *ngIf="searchMode=='v2'">
          <div class="item-container" *ngFor="let item of searchResults; let i = index;">
            <app-grid-item *ngIf="item.mediaType==media" [item]="item" [priceHint]="'search'" [media]="media"
            (onItemClicked)="itemClicked()"
            (onWishlistClicked)="addToWishlist(item, media)"
            (onOwnlistClicked)="addToOwnlist(item, media)"
            (onBlocklistClicked)="addToBlocklist(item, media)"
            (onRemoveFromWishlistClicked)="removeFromWishlist(item, media)"
            (onRemoveFromOwnlistClicked)="removeFromOwnlist(item, media)"></app-grid-item>
          </div>
        </ng-container>

        <ng-container *ngIf="searchMode=='v1'">
          <div class="item-container" *ngFor="let item of searchResults[media]; let i = index;">
            <app-grid-item [item]="item" [priceHint]="'search'" [media]="media"
            (onItemClicked)="itemClicked()"
            (onWishlistClicked)="addToWishlist(item, media)"
            (onOwnlistClicked)="addToOwnlist(item, media)"
            (onBlocklistClicked)="addToBlocklist(item, media)"
            (onRemoveFromWishlistClicked)="removeFromWishlist(item, media)"
            (onRemoveFromOwnlistClicked)="removeFromOwnlist(item, media)"></app-grid-item>
          </div>
        </ng-container>

      </div>

      <div *ngIf="selectedItemType == 'all' && shouldDisplayMoreResults(media)" class="more-results" (click)="moreResultsClicked(media)">{{getString('moreResults')}}</div>

    </div>
  </ng-container>

  <div class="center-txt-box" *ngIf="!showAmazonUSItems()">
    {{getString('cantShowAmazonItems')}} <a class="blue-link" [routerLink]="'/' + getCountry() + '/' + getString('contactUrl')">{{getString('contactUs')}}</a>
  </div>

  <div class="message-div" *ngIf="noMatch">{{getString('noMatchFound')}}</div>

  <div class="results-end" *ngIf="resultsEndReached">{{getString('endOfResults')}}</div>

</div>

<div *ngIf="showSpinner" class="spinner-container txt-algn-cntr">
  <app-spinner></app-spinner>
</div>
<app-scroll-top *ngIf="showScrollToTopButton"></app-scroll-top>
